// eslint-disable-next-line no-restricted-imports
import { makeStyles } from "@material-ui/core/styles";
import { TableCell, TableRow } from "@material-ui/core";
import React, { Fragment } from "react";
import { Badge } from "react-bootstrap";
import { getFormattedNumber } from "../../../helpers/Formatter";
import { useSchoolContext } from "../components/SchoolDataContext";
import { SchoolTableActions } from "../components/SchoolTableActions";

const useStyles = makeStyles((theme) => ({
  activeStatus: {
    color: "white",
    background: "#4BB543",
  },
  inactiveStatus: {
    color: "white",
    background: "#F32013",
  },
  tableWrapper: {
    overflowX: "auto",
  },
}));

export default function SchoolRow(props) {
  const classes = useStyles();
  const { row, reset, setReset, showActions } = props;
  const schoolContext = useSchoolContext();

  return (
    <Fragment>
      <TableRow key={row.school_information_id} hover tabIndex={-1}>
        <TableCell align="center" component="th" scope="row">
          {row.school_information_id}
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          <div style={{ maxWidth: "200px", wordWrap: "break-word" }}>
            <strong>{row.school_name}</strong>
          </div>
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          <div style={{ maxWidth: '200px', wordWrap: 'break-word' }}>
            {row.school_address || "N/A"}
          </div>
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          {row.primary_email || "N/A"}
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          {row.primary_phone ? getFormattedNumber(row.primary_phone) : "N/A"}
        </TableCell>
        <TableCell align="left" component="th" scope="row">
          <Badge
            pill
            className={
              row.active_id === 1
                ? classes.activeStatus
                : classes.inactiveStatus
            }
          >
            {row.active_id === 1 ? "Active" : "Inactive"}
          </Badge>
        </TableCell>
        {showActions && (
          <TableCell align="center">
            <SchoolTableActions
              row={row}
              openEditSchoolPage={schoolContext.openEditSchoolPage}
              openActivateSchoolDialog={schoolContext.openActivateSchoolDialog}
            />
          </TableCell>
        )}
      </TableRow>
    </Fragment>
  );
}